import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { EnvironmentService } from 'src/app/common/services/environment/environment.service';
import { User } from 'src/app/common/state/user/user.model';
import { PaginationDTO } from 'src/app/common/types/responses/responses-template';
import { ModalComponent } from '../../shared/components/modals/modal/modal.component';
import { FileDTO } from '../../shared/dtos/file.dto';
import { InstantFeedbackDTO } from '../../shared/dtos/instant-feedback.dto';
import { InstantFeedbackService } from '../../shared/services/ai/instant-feedback.service';

@Component({
  selector: 'app-smart-feedback-page',
  templateUrl: './smart-feedback-page.component.html',
  styleUrls: ['./smart-feedback-page.component.scss'],
  standalone: false,
})
export class SmartFeedbackPageComponent implements OnInit, OnDestroy {
  @ViewChild('feedbackModal') feedbackModal: ModalComponent;

  user: User | null = null;

  listMeta: PaginationDTO;

  isLoading = false;

  subs: Subscription[] = [];

  tableData: InstantFeedbackDTO[] = [];

  currentFeedback: InstantFeedbackDTO;

  constructor(
    private store: Store,
    private instantFeedbackService: InstantFeedbackService
  ) {
    this.user = this.store.selectSnapshot((state) => state.user.user) as User;
  }

  ngOnInit(): void {
    this.getSmartFeedback();
  }

  getSmartFeedback() {
    this.isLoading = true;
    if (this.user) {
      this.subs.push(
        this.instantFeedbackService
          .getAllSmartFeedbackForUser(this.listMeta?.currentPage || 1)
          .subscribe((res) => {
            if (res) {
              this.tableData = res.items;
              this.listMeta = res._meta;
              this.isLoading = false;
            }
          })
      );
    }
  }

  viewSmartFeedback(feedbackId: number) {
    const feedback = this.tableData.find((fb) => fb.id === feedbackId);
    if (feedback) {
      this.currentFeedback = feedback;
      this.feedbackModal.open();
    }
  }

  // eslint-disable-next-line class-methods-use-this
  viewFile(file: FileDTO) {
    window.open(`${EnvironmentService.apiUrl()}${file.location}`);
  }

  submitUserFeedback(feedbackId: number, direction: string) {
    this.instantFeedbackService
      .submitUserFeedback(feedbackId, direction)
      .subscribe((resp) => {
        if (resp) {
          this.currentFeedback.user_feedback = resp.user_feedback;
        }
      });
  }

  ngOnDestroy() {
    let sub = this.subs.pop();
    while (sub) {
      sub.unsubscribe();
      sub = this.subs.pop();
    }
  }
}
